<template>
    <component :is="activeModal" @accept="++step" :closeAfterSuccess="false" />
</template>

<script>
import ConsentsModal from '@/components/modals/ConsentsModal.vue'
import LotteryConsentModal from '@/components/modals/LotteryConsentModal.vue'
import LotteryLimitedFunctionalityModal from '@/components/modals/LotteryLimitedFunctionalityModal.vue'

export default {
    name: 'LotteryNewUserModals',
    components: {
        ConsentsModal,
        LotteryConsentModal,
        LotteryLimitedFunctionalityModal
    },
    watch: {
        // step watcher for prevent from redundant step filling
        step: {
            immediate: true,
            handler(val) {
                if (val === 1) {
                    const lotteryService = this.$store.getters.getServices.find(
                        service => service.code === 'loterie2_g3'
                    )

                    if (
                        lotteryService &&
                        lotteryService.number_of_entities_with_subscription > 0
                    ) {
                        this.step++
                    }
                } else if (val === 2) {
                    this.$store.getters.getMarketingConsents.every(
                        e => e.state !== null
                    ) && this.step++
                }
            }
        }
    },
    computed: {
        activeModal() {
            let name = ''
            switch (this.step) {
            case 1:
                name = 'LotteryConsentModal'
                break
            case 2:
                name = 'ConsentsModal'
                break
            case 3:
                name = 'LotteryLimitedFunctionalityModal'
                break
            }
            return name
        }
    },
    data() {
        return {
            step: 1
        }
    }
}
</script>
